import { Heading } from '@art-of-hospitality-solutions-llc/ui-kit/components/heading';
import BreadcrumbWrapper from '@Components/BreadcrumbWrapper';
import UserRoleForm from './userRoleForm';
import UserRoleList from './userRoleList';

const UserRoles = () => {
  return (
    <div>
      <BreadcrumbWrapper
        crumbArray={[{ path: '/user-roles', label: 'User Roles' }]}
      />

      <div className="mt-4">
        <div className="flex justify-between">
          <Heading>User Roles</Heading>
          <UserRoleForm />
        </div>
        <UserRoleList />
      </div>
    </div>
  );
};

export default UserRoles;
